import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { BrowserEnvironmentService } from '../services/browser-environment.service';
import { VideocallSessionService } from '../services/videocall-session.service';
import { resolveVideocallRole } from '../videocall/videocall-role';

/**
 * Guard preventivo de compatibilidad de navegador.
 *
 * Regla de negocio: Safari solo se bloquea para el ASISTENTE (inspector). El
 * CLIENTE —típicamente móvil— SÍ puede acceder por Safari.
 *
 * El rol se resuelve con `resolveVideocallRole`:
 *  - En entry/:hash aún no hay token → se usa el query param `mode` (asistente = host).
 *  - En lobby/call ya hay token → se usa el `role` del JWT.
 *  - Si no se puede determinar, por defecto es `client` (no se bloquea).
 */
export const browserSupportGuard: CanActivateFn = (route, state) => {
  const browser = inject(BrowserEnvironmentService);
  const session = inject(VideocallSessionService);
  const router = inject(Router);

  if (!browser.isSafari()) {
    return true;
  }

  const mode = route.queryParamMap.get('mode');
  const payload = session.getSessionTokenPayload();
  const role = resolveVideocallRole(mode, payload);

  // Diagnóstico temporal: permite verificar en la consola qué decide el guard.
  console.warn('[browserSupportGuard]', {
    isSafari: true,
    mode,
    resolvedRole: role,
    hasToken: !!payload,
    url: state.url,
  });

  if (role === 'assistant') {
    // Conserva la URL de entrada (con hash y query) para "Copiar enlace" en Chrome.
    return router.createUrlTree(['/unsupported-browser'], {
      queryParams: { from: state.url },
    });
  }
  // Cliente en Safari: permitido.
  return true;
};
